import { gql } from "graphql-tag";

export const entryFragmentsForFetchAllEntriesQuery = gql`

  #
  # ──────────────────────────
  #  VARIABLE FRAGMENTS
  # ──────────────────────────
  #
  # Don't need variable id in entry fields for now as we only inherit one level (from product) currently
  fragment VariableEntryFields on variable_Entry {
    plainText
    inheritIfEmpty
    variableToInherit {
      # only set on scoped variables
      ... on variable_Entry {
        id
      }
    }
    showForTheFollowingProducts {
      ... on product_Entry {
        id
      }
    }
    showForTheFollowingProductFeatures {
      ... on productFeatures_Category {
        id
      }
    }
    showForTheFollowingProductCategories {
      ... on productCategories_Category {
        id
      }
    }
    variableConditions {
      ... on variable_Entry {
        plainText
        inheritIfEmpty
        showForTheFollowingProducts {
          ... on product_Entry {
            id
          }
        }
        showForTheFollowingProductFeatures {
          ... on productFeatures_Category {
            id
          }
        }
        showForTheFollowingProductCategories {
          ... on productCategories_Category {
            id
          }
        }
      }
    }
  }

  #
  # ──────────────────────────
  #  BASIC BLOCK FRAGMENTS
  # ──────────────────────────
  #

  fragment TextBlockFields on textBlock_Entry {
    id
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    paragraph {
      rawHtml
    }
    pageBreakAfter
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment TextPlusImageBlockFields on textPlusImageBlock_Entry {
    id
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    paragraph {
      rawHtml
    }
    image {
      uid
      url
      width
      height
      focalPoint
      hasFocalPoint
    }
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment LargeImageBlockFields on largeImageBlock_Entry {
    id
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    image {
      uid
      url
      width
      height
      focalPoint
      hasFocalPoint
    }
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment CalloutBlockFields on calloutBlock_Entry {
    id
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    calloutType
    calloutText
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment VideoBlockFields on videoBlock_Entry {
    id
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    youtubeVideo
    paragraph {
      rawHtml
    }
    # Some places have "assetVideo { uid url }" instead of "id url"
    # so ensure your fields match usage:
    assetVideo {
      uid
      url
    }
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment FullWidthImageBlockFields on fullWidthImageBlock_Entry {
    sortOrder
    typeHandle
    sectionHandle
    fieldHandle # for determining if owned by a Matrix - matrix field block mutation name is unique
    image {
      uid
      url
      width
      height
      focalPoint
      hasFocalPoint
    }
    translationImportTimestamp
    showForTheFollowingProducts {
      id
      title
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  fragment RichTextInlineImagesBlockFields on richTextInlineImagesBlock_Entry {
    id
    sortOrder
    typeHandle
    fieldHandle # for determining if owned by Matrix block
    richText {
      rawHtml
    }
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
  }

  #
  # ────────────────────────────────────
  #  COLUMN-LAYOUT BLOCK FRAGMENTS
  # ────────────────────────────────────
  #

  fragment ColumnComposableBlockFields on columnComposableBlock_Entry {
    id
    typeHandle
    showForTheFollowingProducts {
      id
      title
      typeHandle
    }
    showForTheFollowingProductCategories {
      id
      title
    }
    showForTheFollowingProductFeatures {
      id
      title
    }
    showForThisSiteLanguage
    columnBlockComposableEntries {
      sortOrder
      ... on textBlock_Entry {
        ...TextBlockFields
      }
      ... on largeImageBlock_Entry {
        ...LargeImageBlockFields
      }
      ... on textPlusImageBlock_Entry {
        ...TextPlusImageBlockFields
      }
      ... on richTextInlineImagesBlock_Entry {
        ...RichTextInlineImagesBlockFields
      }
      ... on calloutBlock_Entry {
        ...CalloutBlockFields
      }
      ... on videoBlock_Entry {
        ...VideoBlockFields
      }
    }
  }
`;

export default entryFragmentsForFetchAllEntriesQuery.js;
